var render = function () {
  var _vm$pickupAssignmentD, _vm$pickupAssignmentD2, _vm$pickupAssignmentD3, _vm$pickupAssignmentD4, _vm$pickupAssignmentD5, _vm$pickupAssignmentD6, _vm$pickupAssignmentD7, _vm$pickupAssignmentD8, _vm$pickupAssignmentD9, _vm$pickupAssignmentD10, _vm$pickupAssignmentD11, _vm$pickupAssignmentD12, _vm$pickupAssignmentD13, _vm$pickupAssignmentD14, _vm$pickupAssignmentD15, _vm$pickupAssignmentD16, _vm$pickupAssignmentD17, _vm$pickupAssignmentD18, _vm$pickupAssignmentD19, _vm$pickupAssignmentD20, _vm$pickupAssignmentD21, _vm$pickupAssignmentD22, _vm$pickupAssignmentD23, _vm$pickupAssignmentD24, _vm$pickupAssignmentD25, _vm$pickupAssignmentD26, _vm$pickupAssignmentD27, _vm$pickupAssignmentD28, _vm$pickupAssignmentD29, _vm$pickupAssignmentD30, _vm$pickupAssignmentD31, _vm$pickupAssignmentD32, _vm$pickupAssignmentD33, _vm$pickupAssignmentD34, _vm$pickupAssignmentD35, _vm$pickupAssignmentD36, _vm$pickupAssignmentD37, _vm$pickupAssignmentD38, _vm$pickupAssignmentD39, _vm$pickupAssignmentD40, _vm$pickupAssignmentD41;

  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "order text-neutral-500"
  }, [_c('div', {
    staticClass: "bg-white"
  }, [_c('div', {
    staticClass: "flex justify-between items-center gap-3 p-6 shadow-border-b mdmax:flex-col mdmax:items-start"
  }, [_c('div', {
    staticClass: "flex gap-3 mdmax:items-start mdmax:gap-1 mdmax:flex-col justify-between items-center"
  }, [_c('span', [_c('span', {
    staticClass: "inline-flex px-2 py-1 text-sm rounded-md mdmax:flex-shrink-0 capitalize",
    class: _vm.statusClass || 'text-neutral-500 bg-neutral-300'
  }, [_vm._v(_vm._s(_vm.pickupAssignmentDetail.internal))])]), _c('div', [_c('span', {
    staticClass: "text-neutral-500 mdmax:text-sm block text-xs mb-1"
  }, [_vm._v(_vm._s(_vm._f("formatDate")(_vm.pickupAssignmentDetail.order_delivery_schedule)) + " / " + _vm._s(_vm.pickupAssignmentDetail.id))]), _c('span', {
    staticClass: "text-neutral-500 mdmax:text-sm block text-xs"
  }, [_vm._v("Kode Booking: " + _vm._s(_vm.pickupAssignmentDetail.order_booking_code))])])]), (_vm$pickupAssignmentD = _vm.pickupAssignmentDetail) !== null && _vm$pickupAssignmentD !== void 0 && (_vm$pickupAssignmentD2 = _vm$pickupAssignmentD.courier_assigned) !== null && _vm$pickupAssignmentD2 !== void 0 && _vm$pickupAssignmentD2.id ? _c('div', {
    staticClass: "courier flex items-center gap-6"
  }, [(_vm$pickupAssignmentD3 = _vm.pickupAssignmentDetail) !== null && _vm$pickupAssignmentD3 !== void 0 && _vm$pickupAssignmentD3.courier_assigned.partner_icon ? _c('div', {
    staticClass: "partner w-10 h-10 rounded-full flex justify-center items-center"
  }, [_c('img', {
    staticClass: "rounded-full",
    attrs: {
      "src": (_vm$pickupAssignmentD4 = _vm.pickupAssignmentDetail) === null || _vm$pickupAssignmentD4 === void 0 ? void 0 : _vm$pickupAssignmentD4.courier_assigned.partner_icon
    }
  })]) : _vm._e(), _c('div', {
    staticClass: "flex gap-3 items-center"
  }, [_c('div', {
    staticClass: "w-7 h-7 rounded-full flex justify-center items-center"
  }, [_c('img', {
    staticClass: "rounded-full",
    attrs: {
      "src": (_vm$pickupAssignmentD5 = _vm.pickupAssignmentDetail) === null || _vm$pickupAssignmentD5 === void 0 ? void 0 : (_vm$pickupAssignmentD6 = _vm$pickupAssignmentD5.courier_assigned) === null || _vm$pickupAssignmentD6 === void 0 ? void 0 : _vm$pickupAssignmentD6.photo
    }
  })]), _c('div', {}, [_c('p', {
    staticClass: "text-sm"
  }, [_vm._v(_vm._s((_vm$pickupAssignmentD7 = _vm.pickupAssignmentDetail) === null || _vm$pickupAssignmentD7 === void 0 ? void 0 : (_vm$pickupAssignmentD8 = _vm$pickupAssignmentD7.courier_assigned) === null || _vm$pickupAssignmentD8 === void 0 ? void 0 : _vm$pickupAssignmentD8.name))]), _c('p', {
    staticClass: "text-neutral-500 text-xs"
  }, [_vm._v(_vm._s((_vm$pickupAssignmentD9 = _vm.pickupAssignmentDetail) === null || _vm$pickupAssignmentD9 === void 0 ? void 0 : (_vm$pickupAssignmentD10 = _vm$pickupAssignmentD9.courier_assigned) === null || _vm$pickupAssignmentD10 === void 0 ? void 0 : _vm$pickupAssignmentD10.phone_number))])])])]) : _vm._e()]), _c('div', {
    staticClass: "flex mdmax:flex-col"
  }, [_c('div', {
    staticClass: "flex-1"
  }, [_c('div', {
    staticClass: "p-6 shadow-border-b"
  }, [_c('p', {
    staticClass: "text-xl font-bold mb-6 text-neutral-700"
  }, [_vm._v("Berat dan Jenis Paket")]), _c('div', {
    staticClass: "flex justify-start gap-6 mb-4 last:mb-0"
  }, [_c('div', {
    staticClass: "w-2/5"
  }, [_c('p', {
    staticClass: "text-sm font-medium mb-1 text-neutral-700"
  }, [_vm._v("Berat Barang")]), _c('p', [_vm._v(_vm._s(_vm.pickupAssignmentDetail.package_weight_kilos) + "kg")])]), _c('div', {
    staticClass: "w-3/5"
  }, [_c('p', {
    staticClass: "text-sm font-medium mb-1 text-neutral-700"
  }, [_vm._v("Jenis Paket")]), _c('p', [_vm._v(_vm._s(_vm.pickupAssignmentDetail.package_goods_category_display))])])])]), _c('div', {
    staticClass: "p-6"
  }, [_c('p', {
    staticClass: "text-xl font-bold mb-6 text-neutral-700"
  }, [_vm._v("Info Pengiriman")]), _c('div', {
    staticClass: "flex justify-start gap-6 mb-6"
  }, [_c('div', {
    staticClass: "w-2/5"
  }, [_c('p', {
    staticClass: "text-sm font-medium mb-1 text-neutral-700"
  }, [_vm._v("Nama Pengirim")]), _c('p', [_vm._v(_vm._s(((_vm$pickupAssignmentD11 = _vm.pickupAssignmentDetail) === null || _vm$pickupAssignmentD11 === void 0 ? void 0 : (_vm$pickupAssignmentD12 = _vm$pickupAssignmentD11.sender) === null || _vm$pickupAssignmentD12 === void 0 ? void 0 : _vm$pickupAssignmentD12.name) || '-'))])]), _c('div', {
    staticClass: "w-3/5"
  }, [_c('p', {
    staticClass: "text-sm font-medium mb-1 text-neutral-700"
  }, [_vm._v("No. HP Pengirim")]), _c('p', [_vm._v(_vm._s(((_vm$pickupAssignmentD13 = _vm.pickupAssignmentDetail) === null || _vm$pickupAssignmentD13 === void 0 ? void 0 : (_vm$pickupAssignmentD14 = _vm$pickupAssignmentD13.sender) === null || _vm$pickupAssignmentD14 === void 0 ? void 0 : _vm$pickupAssignmentD14.phone_number) || '-'))])])]), _c('p', {
    staticClass: "text-sm font-medium mb-1 text-neutral-700"
  }, [_vm._v("Alamat Pengirim")]), _c('p', [_vm._v(_vm._s(((_vm$pickupAssignmentD15 = _vm.pickupAssignmentDetail) === null || _vm$pickupAssignmentD15 === void 0 ? void 0 : (_vm$pickupAssignmentD16 = _vm$pickupAssignmentD15.sender) === null || _vm$pickupAssignmentD16 === void 0 ? void 0 : _vm$pickupAssignmentD16.address) || '-'))]), _c('div', {
    staticClass: "mt-6 p-2 bg-neutral-200 rounded-md"
  }, [_c('p', {
    staticClass: "text-sm font-medium mb-1 text-neutral-700"
  }, [_vm._v("Detail Pickup")]), _c('p', [_vm._v(_vm._s(((_vm$pickupAssignmentD17 = _vm.pickupAssignmentDetail) === null || _vm$pickupAssignmentD17 === void 0 ? void 0 : (_vm$pickupAssignmentD18 = _vm$pickupAssignmentD17.sender) === null || _vm$pickupAssignmentD18 === void 0 ? void 0 : _vm$pickupAssignmentD18.address_detail_instruction) || '-'))])])]), _c('div', {
    staticClass: "p-6 mdmax:shadow-border-b"
  }, [_c('p', {
    staticClass: "text-xl font-bold mb-6 text-neutral-700"
  }, [_vm._v("Info Penerima")]), _c('div', {
    staticClass: "flex justify-start gap-6 mb-6"
  }, [_c('div', {
    staticClass: "w-2/5"
  }, [_c('p', {
    staticClass: "text-sm font-medium mb-1 text-neutral-700"
  }, [_vm._v("Nama Penerima")]), _c('p', [_vm._v(_vm._s(((_vm$pickupAssignmentD19 = _vm.pickupAssignmentDetail) === null || _vm$pickupAssignmentD19 === void 0 ? void 0 : (_vm$pickupAssignmentD20 = _vm$pickupAssignmentD19.receiver) === null || _vm$pickupAssignmentD20 === void 0 ? void 0 : _vm$pickupAssignmentD20.name) || '-'))])]), _c('div', {
    staticClass: "w-3/5"
  }, [_c('p', {
    staticClass: "text-sm font-medium mb-1 text-neutral-700"
  }, [_vm._v("No. HP Penerima")]), _c('p', [_vm._v(_vm._s(((_vm$pickupAssignmentD21 = _vm.pickupAssignmentDetail) === null || _vm$pickupAssignmentD21 === void 0 ? void 0 : (_vm$pickupAssignmentD22 = _vm$pickupAssignmentD21.receiver) === null || _vm$pickupAssignmentD22 === void 0 ? void 0 : _vm$pickupAssignmentD22.phone_number) || '-'))])])]), _c('p', {
    staticClass: "text-sm font-medium mb-1 text-neutral-700"
  }, [_vm._v("Alamat Penerima")]), _c('p', [_vm._v(_vm._s(((_vm$pickupAssignmentD23 = _vm.pickupAssignmentDetail) === null || _vm$pickupAssignmentD23 === void 0 ? void 0 : (_vm$pickupAssignmentD24 = _vm$pickupAssignmentD23.receiver) === null || _vm$pickupAssignmentD24 === void 0 ? void 0 : _vm$pickupAssignmentD24.address) || '-'))]), _c('div', {
    staticClass: "mt-6 p-2 bg-neutral-200 rounded-md"
  }, [_c('p', {
    staticClass: "text-sm font-medium mb-1 text-neutral-700"
  }, [_vm._v("Detail Pickup")]), _c('p', [_vm._v(_vm._s(((_vm$pickupAssignmentD25 = _vm.pickupAssignmentDetail) === null || _vm$pickupAssignmentD25 === void 0 ? void 0 : (_vm$pickupAssignmentD26 = _vm$pickupAssignmentD25.receiver) === null || _vm$pickupAssignmentD26 === void 0 ? void 0 : _vm$pickupAssignmentD26.address_detail_instruction) || '-'))])])])]), _c('div', {
    staticClass: "flex-1 shadow-border-l mdmax:shadow-none"
  }, [_c('div', {
    staticClass: "p-6"
  }, [_c('p', {
    staticClass: "text-xl font-bold mb-6 text-neutral-700"
  }, [_vm._v("Status Pengiriman")]), _vm._l((_vm$pickupAssignmentD27 = _vm.pickupAssignmentDetail) === null || _vm$pickupAssignmentD27 === void 0 ? void 0 : _vm$pickupAssignmentD27.delivery_statuses, function (tracking, index) {
    return _c('div', {
      key: 'tracking' + index,
      staticClass: "flex gap-5"
    }, [_c('div', {
      staticClass: "line relative"
    }, [_c('span', {
      staticClass: "inline-block w-5 h-5 rounded-full  border-4  relative z-1",
      class: index === 0 ? 'bg-primary-500 border-primary-100' : 'bg-neutral-500 border-neutral-300'
    }), _c('span', {
      staticClass: "absolute border-dashed border-neutral-300 h-full w-px border left-1/2 transform -translate-x-1/2 top-0 z-0"
    })]), _c('div', {
      staticClass: "status mb-6"
    }, [_c('p', {
      staticClass: "text-sm mb-1"
    }, [_vm._v(_vm._s(_vm._f("formatDateTime")(tracking.created_time)))]), _c('p', {
      staticClass: "text-neutral-700 mb-1"
    }, [_vm._v(_vm._s(tracking.title))]), _c('p', {
      staticClass: "text-sm"
    }, [_vm._v(_vm._s(tracking.subtitle))])])]);
  })], 2), !((_vm$pickupAssignmentD28 = _vm.pickupAssignmentDetail) !== null && _vm$pickupAssignmentD28 !== void 0 && (_vm$pickupAssignmentD29 = _vm$pickupAssignmentD28.courier_assigned) !== null && _vm$pickupAssignmentD29 !== void 0 && _vm$pickupAssignmentD29.id) && _vm.pickupAssignmentDetail.internal === 'internal' ? _c('div', {
    staticClass: "p-6"
  }, [_c('div', {
    staticClass: "flex justify-between items-center mb-6"
  }, [_c('p', {
    staticClass: "text-xl font-bold text-neutral-700"
  }, [_vm._v("Kurir Terdekat")]), _c('div', {
    staticClass: "relative"
  }, [_c('TextField', {
    attrs: {
      "type": "text",
      "withIcon": true,
      "placeholder": "Cari kurir"
    }
  }), _c('div', {
    staticClass: "absolute left-3 top-1/2 transform -translate-y-1/2"
  }, [_c('Search')], 1)], 1)]), _c('TableComponent', {
    attrs: {
      "columns": _vm.columns,
      "list": _vm.filteredData
    },
    scopedSlots: _vm._u([{
      key: "table-row",
      fn: function fn(_ref) {
        var entry = _ref.entry,
            column = _ref.column,
            index = _ref.index;
        return [column.field === 'no' ? _c('span', [_vm._v(_vm._s(index + 1))]) : column.field === 'action' ? _c('Button', {
          attrs: {
            "buttonText": _vm.selectedCourier === entry.courier_id ? 'Ditugaskan' : 'Tugaskan',
            "type": _vm.selectedCourier === entry.courier_id ? 'primary' : 'secondary',
            "size": "small"
          },
          on: {
            "action": function action($event) {
              return _vm.selectCourier(entry.courier_id);
            }
          }
        }) : column.field === 'courier' ? _c('span', [_c('div', {
          staticClass: "flex items-center gap-3"
        }, [_c('div', {
          staticClass: "w-7 h-7 rounded-full flex justify-center items-center"
        }, [_c('img', {
          staticClass: "rounded-full",
          attrs: {
            "src": entry.courier_photo
          }
        })]), _c('div', {}, [_c('p', {
          staticClass: "text-sm font-bold"
        }, [_vm._v(_vm._s(entry.courier_name))]), _c('p', {
          staticClass: "text-neutral-500 text-xs"
        }, [_vm._v(_vm._s(entry.courier_phone_number))])])])]) : column.field === 'distance_in_meter' ? _c('span', {
          staticClass: "block"
        }, [_vm._v(" " + _vm._s(_vm.convertDistance(entry[column.field])) + " ")]) : _c('span', [_vm._v(_vm._s(entry[column.field] || '-'))])];
      }
    }], null, false, 1766555790)
  }), _vm.filteredData && _vm.filteredData.length > 0 ? _c('div', {
    staticClass: "mt-8 flex justify-end items-center mb-6"
  }, [_c('pagination', {
    attrs: {
      "currentPage": _vm.currentPage,
      "totalCount": _vm.totalRecords,
      "pageSize": _vm.pageSize
    },
    on: {
      "onPageChange": _vm.onPageChange
    }
  })], 1) : _vm._e()], 1) : _c('div', {
    staticClass: "p-6"
  }, [_c('p', {
    staticClass: "text-xl font-bold text-neutral-700 mb-6"
  }, [_vm._v("Info Kurir")]), _c('div', {
    staticClass: "flex flex-col justify-center items-center"
  }, [_c('div', {
    staticClass: "w-24 h-24 rounded-full flex justify-center items-center mb-3"
  }, [_c('img', {
    staticClass: "rounded-full",
    attrs: {
      "src": (_vm$pickupAssignmentD30 = _vm.pickupAssignmentDetail) === null || _vm$pickupAssignmentD30 === void 0 ? void 0 : (_vm$pickupAssignmentD31 = _vm$pickupAssignmentD30.courier_assigned) === null || _vm$pickupAssignmentD31 === void 0 ? void 0 : _vm$pickupAssignmentD31.photo
    }
  })]), (_vm$pickupAssignmentD32 = _vm.pickupAssignmentDetail) !== null && _vm$pickupAssignmentD32 !== void 0 && (_vm$pickupAssignmentD33 = _vm$pickupAssignmentD32.courier_assigned) !== null && _vm$pickupAssignmentD33 !== void 0 && _vm$pickupAssignmentD33.partner_name ? _c('div', {
    staticClass: "mb-8 text-neutral-700"
  }, [_vm._v(_vm._s((_vm$pickupAssignmentD34 = _vm.pickupAssignmentDetail) === null || _vm$pickupAssignmentD34 === void 0 ? void 0 : (_vm$pickupAssignmentD35 = _vm$pickupAssignmentD34.courier_assigned) === null || _vm$pickupAssignmentD35 === void 0 ? void 0 : _vm$pickupAssignmentD35.partner_name) + " Driver")]) : _vm._e(), _c('p', {
    staticClass: "font-bold text-lg text-neutral-700 mb-2"
  }, [_vm._v(_vm._s((_vm$pickupAssignmentD36 = _vm.pickupAssignmentDetail) === null || _vm$pickupAssignmentD36 === void 0 ? void 0 : (_vm$pickupAssignmentD37 = _vm$pickupAssignmentD36.courier_assigned) === null || _vm$pickupAssignmentD37 === void 0 ? void 0 : _vm$pickupAssignmentD37.name))]), _c('p', {
    staticClass: "text-lg"
  }, [_vm._v(_vm._s((_vm$pickupAssignmentD38 = _vm.pickupAssignmentDetail) === null || _vm$pickupAssignmentD38 === void 0 ? void 0 : (_vm$pickupAssignmentD39 = _vm$pickupAssignmentD38.courier_assigned) === null || _vm$pickupAssignmentD39 === void 0 ? void 0 : _vm$pickupAssignmentD39.phone_number))])])])])]), _c('div', {
    staticClass: "text-xs p-4 flex items-center gap-2 bg-secondary-100 text-neutral-700"
  }, [_c('Info', {
    attrs: {
      "width": "24",
      "height": "24",
      "color": "neutral-700"
    }
  }), _vm._v("Pastikan kurir yang di tugaskan tidak terlalu jauh dari jarak pengambilan. ")], 1), _vm.error ? _c('div', {
    staticClass: "flex justify-end py-2 px-6"
  }, [_c('p', {
    staticClass: "text-system-error"
  }, [_vm._v(_vm._s(_vm.error))])]) : _vm._e(), _c('div', {
    staticClass: "p-6 flex justify-end gap-4 items-center"
  }, [_c('div', {
    staticClass: "w-44 mdmax:w-full"
  }, [_c('LinkButton', {
    attrs: {
      "buttonText": "Kembali",
      "url": "/order/pickup",
      "linkType": "internal",
      "size": "big_full",
      "type": "secondary"
    }
  })], 1), !((_vm$pickupAssignmentD40 = _vm.pickupAssignmentDetail) !== null && _vm$pickupAssignmentD40 !== void 0 && (_vm$pickupAssignmentD41 = _vm$pickupAssignmentD40.courier_assigned) !== null && _vm$pickupAssignmentD41 !== void 0 && _vm$pickupAssignmentD41.id) ? _c('div', {
    staticClass: "w-44"
  }, [_c('Button', {
    attrs: {
      "buttonText": "Submit",
      "size": "big_full"
    },
    on: {
      "action": function action($event) {
        return _vm.submit();
      }
    }
  })], 1) : _vm._e()])])]);
}
var staticRenderFns = []

export { render, staticRenderFns }